var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.39,
    d: "M16.34 8.6h1.78a1.78 1.78 0 0 1 1.78 1.78v9.77l-3.56-3.55h-5.33a1.78 1.78 0 0 1-1.78-1.78v-.89m3.55-5.33a1.78 1.78 0 0 1-1.77 1.78H5.67l-3.55 3.55V4.15c0-.97.8-1.77 1.78-1.77H11a1.78 1.78 0 0 1 1.78 1.77z"
  })));
};
export default SvgMessages;